import { PaymentFailedContent } from 'Modules/purchase/components/PaymentFailedContent/PaymentFailedContent'
import { PurchaseLayout } from 'Modules/purchase/layouts/PurchaseLayout/PurchaseLayout'

export const PaymentFailed = () => (
  <PurchaseLayout>
    <PaymentFailedContent />
  </PurchaseLayout>
)
